import React, { useContext, useState } from "react";
import ErrorList from "../../../components/ErrorList/ErrorList";
import Loading from "../../../components/Loading/Loading";
import { UserContext } from "../../../contexts/AdminUserContext";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";

export default function CreateEmployee() {
    const { user } = useContext(AuthContext);
    const { pushEmployee } = useContext(UserContext);
    const navigate = useNavigate();

    const [employee, setEmployee] = useState({
        fullName: "",
        email: "",
        password: "",
        phoneNumber: "",
        address: "",
        dateOfBirth: "",
        gender: true
    });

    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);

    const validateForm = () => {
        const newErrors = [];

        // Validate fullName
        if (!employee.fullName.trim()) {
            newErrors.push("Họ và tên không được để trống.");
        }

        // Validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!employee.email.trim()) {
            newErrors.push("Email không được để trống.");
        } else if (!emailRegex.test(employee.email)) {
            newErrors.push("Email không hợp lệ.");
        }

        // Validate password
        if (!employee.password) {
            newErrors.push("Mật khẩu không được để trống.");
        } else if (employee.password.length < 6 || !/\d/.test(employee.password) || !/[a-zA-Z]/.test(employee.password)) {
            newErrors.push("Mật khẩu phải có ít nhất 6 ký tự, gồm cả chữ và số.");
        }

        // Validate phoneNumber
        const phoneRegex = /^[0-9]{10}$/;
        if (!employee.phoneNumber.trim()) {
            newErrors.push("Số điện thoại không được để trống.");
        } else if (!phoneRegex.test(employee.phoneNumber)) {
            newErrors.push("Số điện thoại không hợp lệ. Phải có đúng 10 chữ số.");
        }

        // Validate address
        if (!employee.address.trim()) {
            newErrors.push("Địa chỉ không được để trống.");
        }

        // Validate dateOfBirth
        if (!employee.dateOfBirth) {
            newErrors.push("Ngày sinh không được để trống.");
        } else {
            const today = new Date();
            const dob = new Date(employee.dateOfBirth);
            if (dob >= today) {
                newErrors.push("Ngày sinh phải nhỏ hơn ngày hiện tại.");
            }
        }

        setErrors(newErrors);
        return newErrors.length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = name === "gender" ? value === "1" : value;
        setEmployee((prev) => ({ ...prev, [name]: newValue }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);

        if (!validateForm()) {
            return;
        }

        if (!user || !user.token) {
            setErrors(["Không tìm thấy token xác thực. Vui lòng đăng nhập lại."]);
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`/api/User/create-employee`, {
                ...employee,
                gender: employee.gender,
                role: "Manager" // Automatically set role to Manager
            }, {
                headers: {
                    Authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/json"
                }
            });

            // Ensure roleName is included in the employee object
            const newEmployee = {
                ...response.data,
                roleName: "Manager" // Set roleName explicitly
            };

            pushEmployee(newEmployee);
            navigate("/manager/employees");
        } catch (error) {
            console.error("Lỗi khi tạo nhân viên:", error);
            if (error.response?.data?.errors) {
                setErrors(Object.values(error.response.data.errors));
            } else if (error.response?.data?.message) {
                setErrors([error.response.data.message]);
            } else {
                setErrors(["Tạo nhân viên thất bại. Hãy kiểm tra lại thông tin."]);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-4">
            <Loading isLoading={loading} />
            <ErrorList errors={errors} />
            <div className="bg-white shadow-md rounded-lg p-6">
                <h2 className="text-2xl font-bold mb-4">Thêm nhân viên</h2>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <InputField
                            label="Họ và Tên *"
                            name="fullName"
                            value={employee.fullName}
                            onChange={handleChange}
                            required
                        />
                        <InputField
                            label="Email *"
                            name="email"
                            type="email"
                            value={employee.email}
                            onChange={handleChange}
                            required
                        />
                        <InputField
                            label="Mật khẩu *"
                            name="password"
                            type="password"
                            value={employee.password}
                            onChange={handleChange}
                            required
                        />
                        <InputField
                            label="Số điện thoại *"
                            name="phoneNumber"
                            value={employee.phoneNumber}
                            onChange={handleChange}
                            required
                        />
                        <InputField
                            label="Địa chỉ *"
                            name="address"
                            value={employee.address}
                            onChange={handleChange}
                            required
                        />
                        <InputField
                            label="Sinh nhật *"
                            name="dateOfBirth"
                            type="date"
                            value={employee.dateOfBirth}
                            onChange={handleChange}
                            required
                        />
                        <div>
                            <label htmlFor="gender" className="block text-sm font-medium text-gray-700">Giới tính *</label>
                            <select
                                id="gender"
                                name="gender"
                                value={employee.gender ? "1" : "0"}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                required
                            >
                                <option value="1">Nam</option>
                                <option value="0">Nữ</option>
                            </select>
                        </div>
                    </div>
                    <div className="mt-6">
                        <button
                            type="submit"
                            className="w-full md:w-auto bg-blue-600 text-white font-bold py-2 px-4 rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Thêm nhân viên
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

function InputField({ label, name, type = "text", value, onChange, required }) {
    return (
        <div>
            <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
            <input
                type={type}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                required={required}
            />
        </div>
    );
}